/**
 * DroppableGroup — thin wrapper that registers a group container as a
 * drop target using @dnd-kit's `useDroppable`.
 *
 * Used by GroupedTaskList so that empty groups can still receive drops
 * and so collision detection can identify which container the pointer is in.
 */

import type { ReactNode } from "react"
import { useDroppable } from "@dnd-kit/core"

interface DroppableGroupProps {
  /** Unique group/container ID (same key used in SortableContext) */
  id: string
  children: ReactNode
  style?: React.CSSProperties
  className?: string
}

export function DroppableGroup({
  id,
  children,
  style,
  className,
}: DroppableGroupProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { type: "group", groupId: id },
  })

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={className}
      data-group-id={id}
      data-is-over={isOver || undefined}
    >
      {children}
    </div>
  )
}
